import { inject, Pipe, PipeTransform } from '@angular/core';
import { ExcursionModalService } from '../../excursion-modal/excursion-modal.service';
import { Conference, Excursion, ExcursionKeys } from '@ag-common-lib/public-api';
import { ExcursionModalAction } from '../../excursion-modal/excursion-modal.model';
import * as uuid from 'uuid';
import { cloneDeep, get, set } from 'lodash';

@Pipe({ name: 'conferenceExcursionModalAction' })
export class ConferenceExcursionModalActionPipe implements PipeTransform {
  private readonly excursionModalService = inject(ExcursionModalService);

  transform(action: ExcursionModalAction, conference: Conference, path: string) {
    return e => {
      const excursions = get(conference, path);
      if (!Array.isArray(excursions)) {
        set(conference, path, []);
      }

      if (action === ExcursionModalAction.create) {
        return this.excursionModalService.showModal({ action, conference, path });
      }

      const excursion = cloneDeep(e?.row?.data);

      if (action === ExcursionModalAction.copy) {
        const copy = Object.assign({}, excursion, { [ExcursionKeys.date]: null, [ExcursionKeys.id]: uuid.v4() });
        return this.excursionModalService.showModal({ action, conference, path, excursion: copy });
      }

      return this.excursionModalService.showModal({ action, conference, path, excursion });
    };
  }
}
